import React from 'react';
import { Upload, Icon } from 'antd';
import { useUploadActions, useUploadState } from '../../features/upload';
import styles from './UploadBlock.module.scss';

const { Dragger } = Upload;

const UploadBlock = () => {
  const { content, accept } = useUploadState();
  const { onUpload } = useUploadActions();

  const beforeUpload = (file) => {
    onUpload(file);
    return false;
  };

  const props = {
    beforeUpload,
    showUploadList: false,
    accept,
  };

  return (
    <Dragger
      {...props}
      className={styles.root}
    >
      <div className={styles.container}>
        <div>
          <Icon type="plus" />
          <p>Загрузить обложку</p>
        </div>
        {content}
      </div>
    </Dragger>
  );
};

export default UploadBlock;
